<app-loader [message]="'commons.messages.logout' | translate"></app-loader>
